export const createReport = (requested_by) => ({
    type: 'MEETING.DEBUG.CREATE_REPORT',
    payload: {requested_by}
});

export const storeReport = (participant_id, report) => ({
    type: 'MEETING.DEBUG.STORE_REPORT',
    payload: {participant_id, ...report}
});